import { ɵɵdefineInjectable, Injectable, Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function NgxFormErrorComponent_div_1_ng_template_2_Template(rf, ctx) { }
function NgxFormErrorComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtext(1, "\n      ");
    ɵngcc0.ɵɵtemplate(2, NgxFormErrorComponent_div_1_ng_template_2_Template, 0, 0, "ng-template", 3);
    ɵngcc0.ɵɵtext(3, "\n    ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.getTemplate() || _r1)("ngTemplateOutletContext", ctx_r0.getContext());
} }
function NgxFormErrorComponent_ng_template_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(error_r6.message);
} }
function NgxFormErrorComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, "\n      ");
    ɵngcc0.ɵɵtemplate(1, NgxFormErrorComponent_ng_template_3_div_1_Template, 2, 1, "div", 4);
    ɵngcc0.ɵɵtext(2, "\n    ");
} if (rf & 2) {
    const errors_r4 = ctx.errors;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", errors_r4);
} }
class NgxFormErrorConfig {
    constructor() {
        this.errorMessages = {
            min: (context) => {
                return `This value must be bigger than ${context.min}.`;
            },
            max: (context) => {
                return `This value must be smaller than ${context.max}.`;
            },
            required: 'This is required.',
            requiredtrue: 'This must be true.',
            email: 'This must be a valid e-mail address.',
            minlength: (context) => {
                return `This field requires at least ${context.requiredLength} characters.`;
            },
            maxlength: (context) => {
                return `This field must be shorter than ${context.requiredLength} characters.`;
            },
            pattern: 'This field contains an invalid format.',
        };
    }
    getMessage(validator, context) {
        const message = this.errorMessages[validator];
        if (!message) {
            console.warn('[ngx-form-error] could not find message for: ' + validator);
            return 'Error';
        }
        if (message instanceof Function) {
            return message(context);
        }
        return message;
    }
    /**
     * Updates the error messages with the provided messages.
     * Not occuring validations will be kept untouched
     */
    updateMessages(newValidationMessages) {
        this.errorMessages = Object.assign(Object.assign({}, this.errorMessages), newValidationMessages);
    }
    setTemplate(template) {
        this.template = template;
    }
    getTemplate() {
        return this.template;
    }
}
NgxFormErrorConfig.ɵfac = function NgxFormErrorConfig_Factory(t) { return new (t || NgxFormErrorConfig)(); };
NgxFormErrorConfig.ɵprov = ɵɵdefineInjectable({ factory: function NgxFormErrorConfig_Factory() { return new NgxFormErrorConfig(); }, token: NgxFormErrorConfig, providedIn: "root" });
NgxFormErrorConfig.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFormErrorConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class NgxFormErrorComponent {
    constructor(formErrorConfig) {
        this.formErrorConfig = formErrorConfig;
        this.control = null;
    }
    getContext() {
        if (!this.control || !this.control.errors) {
            return { errors: [] };
        }
        return {
            errors: Object.keys(this.control.errors).map(validation => {
                var _a, _b;
                return ({
                    failedValidation: validation,
                    message: this.getMessage(validation, (_b = (_a = this.control) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b[validation]),
                });
            })
        };
    }
    getMessage(error, context) {
        return this.formErrorConfig.getMessage(error, context);
    }
    getTemplate() {
        return this.template || this.formErrorConfig.getTemplate();
    }
}
NgxFormErrorComponent.ɵfac = function NgxFormErrorComponent_Factory(t) { return new (t || NgxFormErrorComponent)(ɵngcc0.ɵɵdirectiveInject(NgxFormErrorConfig)); };
NgxFormErrorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxFormErrorComponent, selectors: [["ngx-form-error"]], inputs: { control: "control", template: "template" }, decls: 6, vars: 1, consts: [["class", "error", 4, "ngIf"], ["default", ""], [1, "error"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngFor", "ngForOf"]], template: function NgxFormErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n    ");
        ɵngcc0.ɵɵtemplate(1, NgxFormErrorComponent_div_1_Template, 4, 2, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n\n    ");
        ɵngcc0.ɵɵtemplate(3, NgxFormErrorComponent_ng_template_3_Template, 3, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtext(5, "\n  ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.control == null ? null : ctx.control.touched) && (ctx.control == null ? null : ctx.control.invalid));
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgForOf], encapsulation: 2 });
NgxFormErrorComponent.ctorParameters = () => [
    { type: NgxFormErrorConfig }
];
NgxFormErrorComponent.propDecorators = {
    control: [{ type: Input }],
    template: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFormErrorComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-form-error',
                template: `
    <div *ngIf="control?.touched && control?.invalid" class="error">
      <ng-template [ngTemplateOutlet]="getTemplate() || default"
                   [ngTemplateOutletContext]="getContext()"></ng-template>
    </div>

    <ng-template #default let-errors="errors">
      <div *ngFor="let error of errors">{{error.message}}</div>
    </ng-template>
  `
            }]
    }], function () { return [{ type: NgxFormErrorConfig }]; }, { control: [{
            type: Input
        }], template: [{
            type: Input
        }] }); })();

class NgxFormErrorModule {
}
NgxFormErrorModule.ɵfac = function NgxFormErrorModule_Factory(t) { return new (t || NgxFormErrorModule)(); };
NgxFormErrorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxFormErrorModule });
NgxFormErrorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxFormErrorModule, { declarations: function () { return [NgxFormErrorComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxFormErrorComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFormErrorModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxFormErrorComponent],
                imports: [
                    CommonModule,
                ],
                exports: [NgxFormErrorComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-form-error
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxFormErrorComponent, NgxFormErrorConfig, NgxFormErrorModule };

//# sourceMappingURL=ngx-form-error.js.map